
tower.initReportQuestionForm = ->
  $form = $('.form-report-question')

  tower.initManageMembers($form, true)

  toggleRepeatSelector($form)
  toggleRepeatTips($form)
  $form.find('input[name="reports_question[every]"]').on 'click', (e) ->
    toggleRepeatSelector($form)

  mp = simple.momentpicker
    el: $form.find('#reports_question_at')
    valueFormat: 'HH:mm'
    displayFormat: 'HH:mm'
  mp._inputValueFormat = 'HH:mm'

  renderQuestionGuidePopover() if $('#tpl-reports-questions').data('autoshow')
  $('.link-template-questions').on 'click', renderQuestionGuidePopover

toggleRepeatSelector = ($form) ->
  $('#repeat-selector').remove()
  $btn = $form.find('input[name="reports_question[every]"]:checked')
  $btn.parent().append($('#tpl-' + $btn.val() + '-repeat-selector').html())
  if $btn.val() == 'day'
    initDaySelector($form)
  if $btn.val() == 'month'
    toggleRepeatTips($form)
    $form.find('#reports_question_on_').change (e) ->
      toggleRepeatTips($form)

toggleRepeatTips = ($form) ->
  $btn = $form.find('input[name="reports_question[every]"]:checked')
  if $btn.val() == 'month'
    day = $('#reports_question_on_').val()
    if ['29', '30', '31'].indexOf(day) != -1
      switch day
        when '29' then key = 'First'
        when '30' then key = 'Second'
        when '31' then key = 'Third'
      tip = $('.month-selector-tip').data('on' + key)
      $('.month-selector-tip').html(tip)
    else
      $('.month-selector-tip').html('')


initDaySelector = ($form) ->
  $item = $form.find('#day-selector')

  if $item.find('input[type="checkbox"]:checked').length == 0
    $item.find('input[type="checkbox"]:first').prop('checked', true)

  $item.on 'change', 'input[type="checkbox"]', ->
    if $item.find('input[type="checkbox"]:checked').length == 0
      $(@).prop('checked', true)

renderQuestionGuidePopover = ->
  $target = $('#reports_question_name')
  popover = simple.popover
    pointTo: $target
    content: $('#tpl-reports-questions').html()
    position: 'bottom-right'
    cls: 'guide-reports-question'
    align: 'left'
    offset:
      x: 23
      y: -8

  popover.el.on 'click', '.tpl-question', ->
    $target.val $(@).find('.tpl-question-name').text()
    popover.destroy()


tower.questionDestroy = ->
  $question = $(@).closest('.question')
  tpl = simple.tpl $('#tpl-report-question-form').html(),
          name: $question.find('.name').text()
          url: $question.find('.question-link').attr('href')

  dialog = simple.dialog
    content: tpl
    width: 650
    modal: true
    buttons: null

  dialog.el.find('.btn-x').on 'click', ->
    dialog.remove()
